import React from 'react';
import PropTypes from 'prop-types';
import { branch, renderNothing } from 'recompose';
import { flowRight } from 'lodash/fp';
import { formValues } from 'redux-form';

import { isCouple, shouldPartnerSign } from '../../../common/utils/hasPartner';
import RadioQuestion from '../../InvestorProfile/RadioQuestion';

import './choiceContact.scss';

const ChoiceContact = ({ rip, hasScpi }) => {
    // L'option couple n'est proposée que pour un SCPI :
    // - active pour un couple marié ou pacsé,
    // - affichée mais désactivée pour un concubin en RIP construit.
    const isCohabitationDualRip = 'cohabitation' === rip.familySituation && rip.dualRip;
    const showCoupleOption = hasScpi && (isCouple(rip.familySituation) || isCohabitationDualRip);

    const choices = {
        client: `${rip.firstName} ${rip.lastName} (client)`,
        partner: `${rip.partnerFirstName} ${rip.partnerLastName} (conjoint)`,
    };

    if (showCoupleOption) {
        choices.clientAndPartner = `${rip.firstName} ${rip.lastName} et ${rip.partnerFirstName} ${rip.partnerLastName}`;
    }

    return (
        <div className="choice-contact">
            <RadioQuestion
                choices={choices}
                disabledChoices={isCohabitationDualRip ? ['clientAndPartner'] : []}
                name="target"
                title={<b>Contact souhaité pour générer le document*</b>}
                className="single"
                required
                errortext="Vous devez choisir une réponse."
            />
        </div>
    );
};

ChoiceContact.propTypes = {
    rip: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        partnerFirstName: PropTypes.string,
        partnerLastName: PropTypes.string,
        familySituation: PropTypes.string,
        dualRip: PropTypes.bool,
    }).isRequired,
    hasScpi: PropTypes.bool,
};

ChoiceContact.defaultProps = {
    hasScpi: false,
};

export default flowRight([
    formValues({ targetForESign: 'target' }),
    branch(
        ({ rip }) => !shouldPartnerSign(rip),
        renderNothing,
    ),
])(ChoiceContact);
